import { ReactNode } from "react";

/**
 * Shell for consumer-facing routes (/t/:tenant_slug/*).
 * Provides a soft tinted background outside a centered 960px column so the
 * mobile-styled flows don't float in pure white on wide displays.
 *
 * Pages keep their own height / background / fixed-position chrome inside.
 */
export const ConsumerPageContainer = ({ children }: { children: ReactNode }) => (
  <div className="min-h-[100dvh] bg-muted/30">
    <div className="mx-auto w-full max-w-[960px] min-h-[100dvh] bg-background shadow-sm">
      {children}
    </div>
  </div>
);

export default ConsumerPageContainer;
